import { DropDown } from '@knitagency/agency-utils';
import Product from '../components/product/Product';

export default class StaticProduct {
  constructor(section) {
    const product = section.el.querySelector('[data-product]');

    if (product) {
      new Product(product);
      this._initDropDown(section);
    }
  }

  _initDropDown(section) {
    const el = section.el.querySelector('[data-product-accordion]');
    new DropDown({
      el: el,
      triggerClass: 'product-info__header',
      contentClass: 'product-info__content',
      closeOnClickOutside: false,
      closeOthers: false,
    });
  }
}
